import { render, staticRenderFns } from "./TextareaComponent.vue?vue&type=template&id=58566240&scoped=true"
import script from "./TextareaComponent.vue?vue&type=script&lang=js"
export * from "./TextareaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58566240",
  null
  
)

export default component.exports